import { render, staticRenderFns } from "./BildirimAyarlari.vue?vue&type=template&id=cda14cf2&"
import script from "./BildirimAyarlari.vue?vue&type=script&lang=js&"
export * from "./BildirimAyarlari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports